import {
  H_PATTERN_CELL_INDICES,
  OBSERVER_TARGET_SECONDS,
} from "@/features/hoverIdle/core/secretProgressLogic";
import type { SecretAchievementDefinition } from "./types";

export const HEAVY_POINTER_HOLD_SECONDS = 30 * 60;
export const X_PATTERN_HOLD_SECONDS = 10;
export const H_PATTERN_HOLD_SECONDS = 10;
export const HOV_O_LABEL_HOVER_SECONDS = 3;
export const HOV_CELL_RAPID_CLICK_TARGET = 10;
export { OBSERVER_TARGET_SECONDS };

export const secretAchievementDefinitions: readonly SecretAchievementDefinition[] =
  [
    {
      id: "observer",
      category: "secret",
      isUnlocked: (snapshot) =>
        snapshot.observerSeconds >= OBSERVER_TARGET_SECONDS,
    },
    {
      id: "heavy-pointer",
      category: "secret",
      isUnlocked: (snapshot) =>
        snapshot.continuousPointerSeconds >= HEAVY_POINTER_HOLD_SECONDS,
    },
    {
      id: "x-pattern-hover",
      category: "secret",
      isUnlocked: (snapshot) =>
        snapshot.xPatternSeconds >= X_PATTERN_HOLD_SECONDS,
    },
    {
      id: "hov-o-label",
      category: "secret",
      isUnlocked: (snapshot) =>
        snapshot.hovOLabelHoverSeconds >= HOV_O_LABEL_HOVER_SECONDS,
    },
    {
      id: "h-pattern-unlock",
      category: "secret",
      isUnlocked: (snapshot) => {
        const unlockedSet = new Set<number>();
        for (const cell of snapshot.hovTargetCells) {
          if (cell.unlocked) unlockedSet.add(cell.index);
        }
        return (
          unlockedSet.size === H_PATTERN_CELL_INDICES.length &&
          H_PATTERN_CELL_INDICES.every((index) => unlockedSet.has(index))
        );
      },
    },
    {
      id: "h-pattern-hover",
      category: "secret",
      isUnlocked: (snapshot) =>
        snapshot.hPatternSeconds >= H_PATTERN_HOLD_SECONDS,
    },
    {
      id: "target-rapid-click",
      category: "secret",
      isUnlocked: (snapshot) =>
        snapshot.hovCellClickWithinWindowCount >= HOV_CELL_RAPID_CLICK_TARGET,
    },
  ];
